module.exports = __webpack_public_path__ + "static/media/opencv.00be4de5.png";